export default __webpack_public_path__ + "static/media/CheckMark_green.876ed4ef.png";